import React from "react";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import { IconButton, Tooltip, Typography } from "@material-ui/core";
import { Check, Clear } from "@material-ui/icons";
import { DictionaryConfigDbRow } from "../../../../types/config";

/** スタイル定義 */
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    tr: {
      width: "100%",
      border: "1px solid rgb(224,224,224)",
      borderLeft: "none",
      borderRight: "none",
      borderBottom: "none",
    },
    td: {
      width: "auto",
      padding: theme.spacing(2),
    },
    tdActions: {
      width: "auto",
      padding: "0px 5px",
    },
    iconButton: {
      color: theme.palette.text.primary,
    },
  })
);

interface Props {
  row?: DictionaryConfigDbRow;
  onApproved: () => any;
  onCanceled: () => any;
}

/** 辞書設定テーブル削除行 */
export function DictionaryConfigRowDelete(props: Props) {
  const classes = useStyles();

  const { onApproved, onCanceled } = props;

  //--------------------
  // コンポーネント
  return (
    <tr className={classes.tr}>
      <td className={classes.td} colSpan={2}>
        <Typography variant="h6">削除してよろしいですか？</Typography>
      </td>
      <td className={classes.tdActions}>
        <div style={{ width: "96px" }}>
          {/* 保存 */}
          <Tooltip title="保存">
            <IconButton className={classes.iconButton} onClick={onApproved}>
              <Check />
            </IconButton>
          </Tooltip>
          {/* キャンセル */}
          <Tooltip title="キャンセル">
            <IconButton className={classes.iconButton} onClick={onCanceled}>
              <Clear />
            </IconButton>
          </Tooltip>
        </div>
      </td>
    </tr>
  );
}
